"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
var React = __importStar(require("react"));
var mdbreact_1 = require("@aon/mdbreact");
var ToastContainer_1 = require("./ToastContainer");
var ToastContent_1 = require("./ToastContent");
var Toast = /** @class */ (function (_super) {
    __extends(Toast, _super);
    function Toast(props) {
        var _this = _super.call(this, props) || this;
        _this.toastId = '';
        _this.notify = function () {
            _this.toastId = (0, mdbreact_1.toast)(React.createElement(ToastContent_1.ToastContent, __assign({}, _this.props)));
        };
        _this.notify = _this.notify.bind(_this);
        _this.update = _this.update.bind(_this);
        return _this;
    }
    Toast.prototype.componentDidUpdate = function () {
        this.InitToast();
    };
    Toast.prototype.componentDidMount = function () {
        this.InitToast();
    };
    Toast.prototype.componentWillUnmount = function () {
        mdbreact_1.toast.dismiss();
    };
    Toast.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(ToastContainer_1.ToastContainer, { position: this.props.position || 'top-right', autoClose: this.props.autoClose ? 3000 : this.props.autoClose, closeButton: this.props.closeButton, closeOnClick: this.props.closeOnClick, pauseOnHover: this.props.pauseOnHover, newestOnTop: this.props.newestOnTop === false ? this.props.newestOnTop : true, className: 'tws-toast-container' + (this.props.className ? ' ' + this.props.className : ''), style: this.props.style, toastClassName: 'toastClass tws-toast', bodyClassName: this.props.bodyClassName, hideProgressBar: this.props.hideProgressBar || false, progressClassName: 'progressClass', iconSize: this.props.iconSize })));
    };
    Toast.prototype.update = function () {
        mdbreact_1.toast.update(this.toastId, __assign({ render: React.createElement(ToastContent_1.ToastContent, __assign({}, this.props)) }, this.props));
    };
    Toast.prototype.InitToast = function () {
        this.props.preventDuplicate ? (!mdbreact_1.toast.isActive(this.toastId) || this.toastId === '' ? this.notify() : this.update()) : this.notify();
    };
    Toast.defaultProps = {
        iconSize: 'md',
        pauseOnHover: false,
    };
    return Toast;
}(React.PureComponent));
exports.Toast = Toast;
